module.exports = __webpack_public_path__ + "static/media/mp3.e47eada1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/attachment-icons/mp3.svg
// module id = 1692
// module chunks = 17